module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-ford.cf78273e.png";